import AREAS from './areas'
import { PERFILES } from '@/perfiles.js'
import AREAS_PERFILES from './AreasPerfiles'

export default class UpdateNotificationDto {
  constructor(data, perfil) {
    this.fk_idPersonalResponsable = data.responsable ?? null
    this.fk_idPersonalAfectado = data.afectado ?? null
    this.título = data.titulo ?? ''
    this.mensaje = data.mensaje ?? ''
    this.prioridad = data.prioridad ?? ''
    this.categoría = data.categoria ?? ''
    this.armeria = AREAS_PERFILES[AREAS.ARMERIA]?.includes(perfil) ? 2 : data.armeria
    this.equipamiento = AREAS_PERFILES[AREAS.EQUIPAMIENTO]?.includes(perfil) ? 2 : data.equipamiento
    this.ifcsp = AREAS_PERFILES[AREAS.IFCSP]?.includes(perfil) ? 2 : data.ifcsp
    this.desarrollo_policial = AREAS_PERFILES[AREAS.DESARROLLO_POLICIAL]?.includes(perfil)
      ? 2
      : data.desarrollo_policial
    this.enlace_c3 = AREAS_PERFILES[AREAS.ENLACE_C3]?.includes(perfil) ? 2 : data.enlace_c3
    this.recursos_humanos = AREAS_PERFILES[AREAS.RECURSOS_HUMANOS]?.includes(perfil) ? 2 : data.recursos_humanos
    this.registro_personal = AREAS_PERFILES[AREAS.REGISTRO_PERSONAL]?.includes(perfil) ? 2 : data.registro_personal
    this.enlace_comisaria = AREAS_PERFILES[AREAS.ENLACE_COMISARIA]?.includes(perfil) ? 2 : data.enlace_comisaria
    this.ejecutivo = AREAS_PERFILES[AREAS.EJECUTIVO]?.includes(perfil) ? 2 : data.ejecutivo
  }

  toPrimitives() {
    return { ...this }
  }
}
